import productHeaders from '@/constants/productHeaders';
const getTypeByHeaderName = (params) => {
  const {
    headerObj = {
    }, showFieldProduct = false,
  } = params || {
  };
  const {
    name = '',
    type = '',
    multiline = false,
    formulaType = '',
    arrayType = '',
  } = headerObj || {
  };
  // TODO: remove this once we have updated the schema to show dropdown with single value
  if (name === productHeaders.INGRESS_CLASSIFICATION || name === productHeaders.MANUFACTURER || name === productHeaders.ORIGIN || name === productHeaders.SHIP_FROM) {
    return 'DROPDOWN';
  }
  if (name === productHeaders.TYPE_DESIGNATION) {
    return 'TYPE_COL';
  }
  if (showFieldProduct) {
    if (name === 'Product Reference') {
      return 'FIELD_PRODUCT_REFERENCE';
    }
    if (name === 'Product Equal') {
      return 'FIELD_PRODUCT_EQUAL';
    }
  }
  if (name === 'order') {
    return 'ORDER_COL';
  }
  switch (type) {
  case 'string':
    if (multiline) {
      return 'MULTILINE';
    } else {
      return 'MULTILINE';
      // return 'SINGLE';
    }
  case 'attachment':
    return 'ARRAY_AIRTABLE_IMAGE';
  case 'number':
    return 'NUMBER';
  case 'url':
    return 'URL';
  case 'currency':
    return 'CURRENCY';
  case 'unit_price':
    return 'CURRENCY_WITH_UNIT';
  case 'relation':
    return 'ASSOCIATED_DOCUMENTS';
  case 'checkbox':
    return 'CHECKBOX';
  case 'date':
    return 'DATE';
  case 'integer':
    if (['Total Cost', 'Budget Price'].includes(name)) {
      return 'CURRENCY';
    }
    if (['Quantity', 'Efficacy (lm/w)'].includes(name)) {
      return 'NUMBER';
    }
    break;
  case 'float':
    if (['Total Cost', 'Budget Price'].includes(name)) {
      return 'CURRENCY';
    }
    if (['Quantity', 'Efficacy (lm/w)'].includes(name)) {
      return 'NUMBER';
    }
    break;
  case 'formula':
    return formulaType ? `FORMULA_${formulaType.toUpperCase()}` : 'FORMULA';
  case 'array':
    if (arrayType === 'string' && name.includes('Link')) {
      return 'URL';
    }
    if (arrayType === 'string') {
      return 'DROPDOWN';
    }
    if (arrayType === 'attachment' || arrayType === 'airtableImage') {
      return 'ARRAY_AIRTABLE_IMAGE';
    }
    if (arrayType === 'url') {
      return 'URL_MULTILINE';
    }
    break;
  default:
    return 'FORMULA';
  }
};
export default getTypeByHeaderName;
